<template>
    <Badge color="dark" class="me-1">
        <Icon icon="tag" /> <span v-if="title">{{ title }}</span><slot v-else></slot>
    </Badge>
</template>

<script>
    import Badge from '../Badge'
    import Icon from '../Icons/Icon'

    export default {
        name: 'Tag',
        components: {
            Icon,
            Badge
        },
        props: {
            title: String
        }
    }
</script>